import { useState } from "react";
import { Check, Link as LinkIcon, Linkedin } from "lucide-react";

const BASE = "inline-flex items-center gap-2.5 rounded-full font-bold transition-colors duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand";

export const SubscribeButton = ({ label, href, note, compact = false, testId }) => {
  const link = (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`${label} to Prasara on LinkedIn (opens in a new tab)`}
      className={`${BASE} bg-brand text-white hover:bg-brand-green hover:text-brand-black ${compact ? "px-4 py-1.5 text-xs" : "px-6 py-3 text-sm"}`}
      data-testid={testId}
    >
      <Linkedin className={compact ? "h-3.5 w-3.5" : "h-4 w-4"} aria-hidden="true" />
      {label}
    </a>
  );
  if (compact) return link;
  return (
    <div className="fade-up mt-8" style={{ animationDelay: "200ms" }}>
      {link}
      {note && <p className="mt-3 text-sm text-ink-muted" data-testid={`${testId}-note`}>{note}</p>}
    </div>
  );
};

const shareUrl = (kind, slug) => `${process.env.REACT_APP_BACKEND_URL}/api/share/${kind}/${encodeURIComponent(slug)}`;

const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const el = document.createElement("textarea");
    el.value = text;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    el.select();
    const ok = document.execCommand("copy");
    el.remove();
    return ok;
  }
};

const OUTLINE = `${BASE} border border-brand px-5 py-2.5 text-sm text-brand hover:bg-brand hover:text-white`;

export const ShareBar = ({ kind, slug, t }) => {
  const [copied, setCopied] = useState(false);
  const url = shareUrl(kind, slug);
  const prefix = kind === "stories" ? "story" : "event";
  const onCopy = async () => {
    if (await copyText(url)) {
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    }
  };
  return (
    <div className="flex flex-wrap gap-3">
      <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer"
        aria-label={`${t(`${kind}.detail.share`)} (opens in a new tab)`} className={OUTLINE} data-testid={`${prefix}-share-linkedin`}>
        <Linkedin className="h-4 w-4" aria-hidden="true" />
        {t(`${kind}.detail.share`)}
      </a>
      <button type="button" onClick={onCopy} className={OUTLINE} data-testid={`${prefix}-copy-link`} data-share-url={url}>
        {copied ? <Check className="h-4 w-4" aria-hidden="true" /> : <LinkIcon className="h-4 w-4" aria-hidden="true" />}
        <span aria-live="polite">{copied ? t(`${kind}.detail.copied`) : t(`${kind}.detail.copy`)}</span>
      </button>
    </div>
  );
};
